<mat-card style="border-color: #5775a8;">
  <mat-card-header cdkDrag cdkDragRootElement=".cdk-overlay-pane" cdkDragHandle style="background-color: #5775a8;">
    <div class="flex flex-row rounded-lg w-full">
      <div class="flex flex-col w-full">
        <h4 style="color:white;">Site Visit</h4>
      </div>
      <!-- <div class="flex flex-col w-full">
        <h4 style="color:white;">Edit Site Visit</h4>
      </div> -->
    </div>
  </mat-card-header>

  <mat-card-content>
    <form [formGroup]="form">
      <div class="flex flex-col">
        <mat-form-field class="container">
          <mat-label>Site Visit Date</mat-label>
          <input matInput [matDatepicker]="visitDate" formControlName="visitDate">
          <mat-datepicker-toggle matSuffix [for]="visitDate"></mat-datepicker-toggle>
          <mat-datepicker #visitDate></mat-datepicker>
          <mat-error *ngIf="form.get('visitDate').invalid">
            Invalid Date.
          </mat-error>
        </mat-form-field>
        <div>
          <small style="color:grey;"><br />Date must be within 30 days of the Complaint Submitted Date:
            <span style="color:red;">{{localComplaint.complaintDate}}</span></small>
        </div>
        <br/>
        <div class="flex flex-col w-full" style="align-items: baseline;">
          <span>Was the site visit conducted</span>
          <mat-radio-group formControlName="visitConducted">
            <mat-radio-button color="primary" class="p-x-8" value='1'
              (change)="siteVisitUpdate('1')">Yes</mat-radio-button>
            <mat-radio-button color="primary" class="p-l-8" value='0'
              (change)="siteVisitUpdate('0')">No</mat-radio-button>
          </mat-radio-group>
        </div>
        
        <div *ngIf="!followupFlag" class="flex flex-col">
          <span>Reason why Site Visit was not conducted?</span>
          <mat-radio-group formControlName="visitConductedReason">
            <mat-radio-button color="primary" class="p-x-8" value='1'>Site Visit Denied (Forwarded to
              OHA)</mat-radio-button>
            <mat-radio-button color="primary" class="p-l-8" value='2'>Failure to develop Remediation Plan (Forwarded to
              OHA)</mat-radio-button>
            <mat-radio-button color="primary" class="p-l-8" value='3'>Other - Explain in Comments</mat-radio-button>
          </mat-radio-group>
        </div>

        <div *ngIf="followupFlag" class="flex flex-col">
          <span>Violation found?</span>
          <mat-radio-group formControlName="violationFound">
            <mat-radio-button color="primary" class="p-x-8" value='1'>Yes</mat-radio-button>
            <mat-radio-button color="primary" class="p-l-8" value='0'>No &mdash; Complaint Resolved</mat-radio-button>
          </mat-radio-group>
        </div>
        <div class="flex clex-col w-full">
          <mat-form-field class="w-full">
            <mat-label>Site Visit Notes</mat-label>
            <textarea matInput cdkTextareaAutosize formControlName="comments" cdkAutosizeMinRows="6"></textarea>
          </mat-form-field>
        </div>

        <div class="flex flex-row w-full">
					<div style="padding-right: 20px;">
						<button mat-raised-button (click)="save()" style="padding-right: 20px; background: #7ABDF3;">
							Save
						</button>
					</div>

					<div style="padding-right: 20px;">
						<button mat-raised-button (click)="return()" style="padding-right: 20px;">
							Return
						</button>
					</div>
				</div>

      </div>

    </form>

  </mat-card-content>

</mat-card>